/* eslint-disable react/prop-types */
import { useState, useEffect } from 'react'
import { motion, AnimatePresence } from "framer-motion"
import SwitchSelector from "react-switch-selector";
import AccordionBike from '../components/Accordion';

import { Link } from 'react-router-dom';
import { routes } from '../helpers/Routes';
import { useHome } from '../contexts/HomeContext';
import { formatCurrency } from '../utils/formatters';


const SlideHome = () => {
    const { doubleSlider, isLoading } = useHome();
    const [isSwapped, setIsSwapped] = useState(false);
    const [buttonActive, setButtonActive] = useState(1);
    const [heightBici, setHeightBici] = useState(1);
    const [size, setSize] = useState('');

    const activeProduct = !isSwapped 
        ? doubleSlider?.product1?.productable ? {...doubleSlider?.product1?.productable, type: doubleSlider?.product1?.type}  : undefined
        :  doubleSlider?.product1?.productable ? {...doubleSlider?.product2?.productable, type: doubleSlider?.product2?.type}  : undefined
        
    console.log(activeProduct)
    const activeInventory = activeProduct?.inventories?.[0] || {};
    const activeImages = activeInventory?.images || [];

    const data = {
        description: {
            h1: activeProduct?.name || '',
            peso: activeProduct?.details?.peso || '',
            tenedor: activeProduct?.details?.tenedor || '',
            tipo_marco: activeProduct?.details?.tipo_marco || '',
            tamañoDeLasLlantas: '',
            frenos: activeProduct?.details?.frenos || '',
            grupo: activeProduct?.details?.grupo || '',
            manubrio: activeProduct?.details?.manubrio || '',
            tamañoDelMarco: activeProduct?.details?.tamaño_marco || ''
        },
        id: activeProduct?.id || '',
        dimensions: activeProduct ? activeProduct.inventories.map(inv => inv.size) : [],
        heights: [450, 480, 500, 520],
        price: activeProduct?.price || '',
        type: activeProduct?.type || '',
        slug: activeProduct?.slug || '',
        peso: activeProduct?.details?.peso || '',
        bikes: activeProduct?.inventories?.map((img, index) => ({
            id: index + 1,
            color: img.color_hex || '#000000',
            image: img?.images?.find(i => i.is_main)?.pathname
        }))
    };


    useEffect(() => {
        setButtonActive(1)
        if (data.heights && data.heights.length > 0) {
            setHeightBici(data.heights[0])
        }
    }, [isSwapped]);

    const handleSwap = () => {
        setIsSwapped(!isSwapped)
    }

    console.log(data)
    if (isLoading) {
        return <div>Loading...</div>
    }

    // Remove bikes with duplicate colors
    const uniqueColorBikes = data?.bikes?.filter(
        (bike, index, self) =>
            self.findIndex(b => b.color === bike.color) === index
    );

    return (
        <section className='section-bike' style={{ marginBottom: "400px" }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }} className="container-bike-selector-marcas">
                <div></div>
                <h2 style={{ fontSize: "34px", color: "#fff", transition: ".4s" }} className="bike-h2">{data.description.h1}</h2>
                <div style={{ height: 40, width: 120, marginRight: "70px"}} className="margin-select">
                    <SwitchSelector
                        backgroundColor={"#ccc"}
                        selectedBackgroundColor={"#000"}
                        initialSelectedIndex={0}
                        onChange={handleSwap}
                        options={[
                            {
                                label: doubleSlider?.product1?.productable?.name?.split(' ')[0] || 'Producto 1',
                                value: "product1"
                            },
                            {
                                label: doubleSlider?.product2?.productable?.name?.split(' ')[0] || 'Producto 2',
                                value: "product2"
                            }
                        ]}
                    />
                </div>
            </div>

            <div className="container-bike container-bike-component">
                <div className="bike">
                    <motion.div
                        className="child"
                        style={{ marginTop: "180px", color: "#000" }}
                        initial={{ right: 0, opacity: 1 }}
                        animate={{ right: isSwapped ? "calc(100% - 627px)" : 0, opacity: isSwapped ? [0.6, 0.0, 0, 0.4, 0.6, 1] : [1, 0.6, 0, 0.0, 0.4, 0.6, 1] }}
                        transition={{
                            duration: .8,
                            times: [0, 0.4, 0.6, 1],
                            ease: "easeInOut",
                        }}
                    >

                        <img src={data?.bikes?.find(i => i?.id == buttonActive)?.image} alt="" style={{ marginLeft: "30px", width: "700px", height: "400px", marginRight: isSwapped ? "30px" : "0", marginTop: "80px", paddingBottom: "30px", objectFit: "contain" }} />
                        <div style={{ display: "flex", justifyContent: "center" }}>
                            <div className="staff-container">
                                <div className='section-staff'>
                                    <span>Precio: </span>
                                    <span>{formatCurrency(data?.price)}</span>
                                </div>
                                <div className='section-staff' style={{ display: "flex", alignItems: "center" }}>
                                    <span>Marco: </span>
                                    <span style={{ marginLeft: "10px" }}>{data?.description.tipo_marco}</span>
                                </div>
                                <div className='section-staff'>
                                    <span>Grupo: </span>
                                    <span style={{ marginLeft: "10px" }}>{data?.description.grupo}</span>
                                </div>
                            </div>
                        </div>

                    </motion.div>

                    <motion.div
                        className="child"
                        style={{ marginTop: "160px", width: "400px" }}
                        initial={{ left: 0, opacity: 1 }}
                        animate={{ left: isSwapped ? "calc(100% - 528px)" : 0, }}
                        transition={{
                            duration: .8,
                            times: [0, 0.4, 0.6, 1],
                            ease: "easeInOut"
                        }}
                    >
                        <AccordionBike data={data} setSize={setSize} />
                        <div>
                            <div className="buttons-color" style={{ marginTop: "30px" }}>
                                {uniqueColorBikes?.map(data => (
                                    <button 
                                        key={data?.id} 
                                        style={{ backgroundColor: data?.color }} 
                                        onClick={() => setButtonActive(data?.id)} 
                                        className={`${buttonActive == data?.id ? "button-active" : ""}`} 
                                    />
                                ))}
                            </div>

                            <div style={{ display: "flex", justifyContent: "center", marginTop: "50px" }}>
                                <Link className="cart-add-button" style={{ textAlign: "center" }} to={`/producto/${data?.type === "bicycle" ? "bike" : "scooter"}/${data?.slug}`}>Ver más</Link>
                            </div>
                        </div>
                    </motion.div>

                </div>

                <div className='bike-responsive' style={{ display: "none" }}>
                    <AnimatePresence mode="wait">
                        {!isSwapped ? (
                            <motion.img
                                key="image2"
                                src={data?.bikes?.find(i => i?.id == buttonActive)?.image}
                                alt="Imagen 2"
                                className="image-bike-responsive"
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0 }}
                                transition={{ duration: 0.5, ease: "easeInOut" }}
                            />
                        ) : (
                            <motion.img
                                key="image1"
                                src={data?.bikes?.find(i => i?.id == buttonActive)?.image}
                                alt="Imagen 1"
                                className="image-bike-responsive"
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0 }}
                                transition={{ duration: 0.5, ease: "easeInOut" }}
                            />
                        )}
                    </AnimatePresence>
                    <div className="buttons-color" style={{ marginTop: "30px" }}>
                        {uniqueColorBikes?.map(data => (
                            <button 
                                key={data?.id} 
                                style={{ backgroundColor: data?.color }} 
                                onClick={() => setButtonActive(data?.id)} 
                                className={`${buttonActive == data?.id ? "button-active" : ""}`} 
                            />
                        ))}
                    </div>

                    <div style={{ display: "flex", justifyContent: "center", marginTop: "50px" }}>
                        <Link className="cart-add-button" style={{ textAlign: "center" }} to={`/producto/${data?.type === "bicycle" ? "bike" : "scooter"}/${data?.slug}`}>Ver más</Link>
                    </div>

                </div>
            </div>
        </section >

    )
}

export default SlideHome;